import { IhelperInitialState } from "./types";
import { LOCAL_STORAGE } from "../../globals/globals";

const storedNavItem = localStorage.getItem(LOCAL_STORAGE.SELECTED_NAV_ITEM) || undefined;

export const initialState: IhelperInitialState = {
  toastDetail: {
    openToast: false,
    message: "",
    toastType: "",
  },
  openConfirmDialog: undefined,
  openCustomDialog: false,
  basicDialogOpenFor: undefined,
  deviceCount: {
    disconnectedDeviceCount: 0,
    allDeviceCount: 0,
    inMaintenanceModeCount: 0,
    ungroupedCount: 0,
    kpiSyncErrorCount : 0,
    offLineDeviceCount : 0,
    configMismatchCount: 0,
  },
  selectedNavListItems: storedNavItem ? { nodeItemIndex: storedNavItem } : {},
  paginationModel: {},
  pagination: {
    page: 0,
    pageSize: 10,
  },
  configAlertCount: 0,
  notificationCount: 0,
  activeTab: 0,
  activeMainTab: "",
  alarmsCount: 0,
  errorMsg: {},
  isLoadingStatus: {},
  rowModesModel: {},
  serverMaintenanceMode: false,
  sortModel: {},
};
